import React, { useMemo } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { Link } from 'react-router-dom';
import { formRules } from 'common/const/common.const';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ECommonFormType } from 'common/models/commonModel';
import { getTextFieldMinMaxLenght, useFormMapper } from 'common/helpers/form.helper';
import { useIsContentRestricted } from 'common/hooks/useIsContentRestricted';
import { useAppSelector } from 'app/store/store.hooks';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import {
  IBitecoinRewardCategoryCreateParams,
  IBitecoinRewardCategoryUpdateParams,
} from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  createRewardCategory: (data: IBitecoinRewardCategoryCreateParams) => void;
  updateRewardCategory: (data: IBitecoinRewardCategoryUpdateParams) => void;
  deleteRewardCategory: () => void;
  typeForm: ECommonFormType;
}

const BitecoinRewardCategoryFormComponent: React.FC<IComponentProps> = (props) => {
  const {
    bitecoinRewardCategoryModel,
    bitecoinRewardCategoryModelLoading,
    bitecoinRewardCategoryModelParams,
    bitecoinRewardCategoryModelError,
  } = useAppSelector((state) => state.bitecoin);
  const { createRewardCategory, updateRewardCategory, typeForm, deleteRewardCategory } = props;
  const id = bitecoinRewardCategoryModel?.id;
  const isCreateForm = typeForm === ECommonFormType.Add;
  const canManageRewardCategory = !useIsContentRestricted();
  const isFieldDisabled = bitecoinRewardCategoryModelLoading || !canManageRewardCategory;
  const { fields } = useFormMapper(
    ['name'],
    bitecoinRewardCategoryModel,
    bitecoinRewardCategoryModelParams,
    bitecoinRewardCategoryModelError
  );
  const { min, max } = useMemo(() => getTextFieldMinMaxLenght('name'), []);

  const addRewardCategory = (values: any) => {
    const { name } = values;

    createRewardCategory({ name: name.trim() });
  };

  const editRewardCategory = (values: any) => {
    const { name } = values;

    if (id) {
      updateRewardCategory({ name });
    }
  };

  return (
    <Form
      className="mt-5"
      onFinish={isCreateForm ? addRewardCategory : editRewardCategory}
      fields={fields}
      layout="vertical"
    >
      <Form.Item rules={[formRules.required, min, max]} name="name" label="Category name">
        <Input name="name" type="text" placeholder="Category name" disabled={isFieldDisabled} />
      </Form.Item>
      <Row className="flex-noWrap" justify="space-between" align="middle">
        <Col span={12}>
          <Row className="flex-noWrap">
            <Form.Item className="mb-0 mr-5">
              <Button
                htmlType="submit"
                type="primary"
                disabled={bitecoinRewardCategoryModelLoading || !canManageRewardCategory}
                loading={bitecoinRewardCategoryModelLoading}
                title={isCreateForm ? 'Add' : 'Save'}
              >
                {isCreateForm ? 'Add' : 'Save'}
              </Button>
            </Form.Item>

            <Link to={`${ERoutesPrivate.Bitecoin}?tab=${EBitecoinPageTabKeys.RewardCategories}`}>
              <Button
                disabled={bitecoinRewardCategoryModelLoading}
                loading={bitecoinRewardCategoryModelLoading}
                title="Cancel"
              >
                Cancel
              </Button>
            </Link>
          </Row>
        </Col>
        {!isCreateForm && (
          <Button
            danger
            disabled={bitecoinRewardCategoryModelLoading || !canManageRewardCategory}
            loading={bitecoinRewardCategoryModelLoading}
            title="Delete"
            onClick={deleteRewardCategory}
          >
            Delete
          </Button>
        )}
      </Row>
    </Form>
  );
};

export const BitecoinRewardCategoryForm = BitecoinRewardCategoryFormComponent;
